
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'TNMStaging',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/TNMStaging.vue